import './OpCheckbox.scss'

import React from 'react'
import cx from 'bem-classnames'

const OpCheckbox = ({label, checked, disabled, onChange, buttonClass, labelClass, dataTestId}) => {
  const buttonClasses = {
    name: 'OpCheckbox__button',
    modifiers: ['checked', 'disabled'],
  }

  const labelClasses = {
    name: 'OpCheckbox__label',
    modifiers: ['disabled']
  }

  let buttonClazz = cx(buttonClasses, {
    checked,
    disabled,
  })
  if (buttonClass) {
    buttonClazz += ` ${buttonClass}`
  }

  let labelClazz = cx(labelClasses, {
    disabled
  })
  if (labelClass) {
    labelClazz += ` ${labelClass}`
  }

  return (
    <div className="OpCheckbox">
      <div data-testid={dataTestId || label} className={buttonClazz} onClick={() => !disabled && onChange && onChange()} />
      <label className={labelClazz}>{label}</label>
    </div>
  )
}

export default OpCheckbox
